import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment-timezone';
import { Text } from '@famly/mf_data-display_text';
import { Box } from '@famly/mf_layout_box';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { useUpdateError } from '@famly/stat_ts-utils_global-messages';
import * as ChildCheckinActions from 'signin-app/child/check-in/actions';
import * as LoginSelectors from 'signin-app/login/selectors';
import * as ChildSelectors from 'signin-app/child/selectors';
import { Card, CardsContainer } from 'signin-app/groups/group-item';
import translate from 'signin-app/helpers/translate';
import * as GroupsSelectors from 'signin-app/groups/selectors';
import { ActionOnClickButton, BottomBarContainer } from 'signin-app/components/action-buttons';
import { useCheckOutChild } from './check-out-child-context';
export const RoomSwitcher = () => {
    const { child, displayName } = useCheckOutChild();
    const childId = child.id;
    const dispatch = useDispatch();
    const updateError = useUpdateError();
    const timezone = useTypedSelector(GroupsSelectors.timezone);
    const groups = useTypedSelector(GroupsSelectors.groups);
    const accessToken = useTypedSelector(LoginSelectors.accessToken);
    const currentChildGroupId = useTypedSelector(state => ChildSelectors.currentChildGroupId(state, { id: childId }));
    const [selectedRoomId, setSelectedRoomId] = React.useState(() => currentChildGroupId);
    const selectedRoom = React.useMemo(() => {
        return groups.find(group => group.groupId === selectedRoomId);
    }, [groups, selectedRoomId]);
    const handleChildSwitchRoom = React.useCallback(() => {
        var _a;
        if (((_a = child.lastCheckIn) === null || _a === void 0 ? void 0 : _a.pickupTime) && timezone) {
            const parsedPickupTime = moment(child.lastCheckIn.pickupTime).tz(timezone);
            const currentTime = moment.tz(timezone);
            if (parsedPickupTime < currentTime) {
                updateError(translate('pickupBeforeNowError'), {
                    sticky: false,
                    duration: 6000,
                });
                return;
            }
        }
        if (child && child.lastCheckIn && timezone) {
            const successMessage = translate('hasMovedRoom', { personName: displayName });
            const parsedPickupTime = child.lastCheckIn.pickupTime
                ? moment(child.lastCheckIn.pickupTime).tz(timezone)
                : null;
            dispatch(ChildCheckinActions.checkInChild.action({
                accessToken,
                childId: child.id,
                pickupRelationId: child.lastCheckIn.pickupRelationId,
                selectedHours: parsedPickupTime ? parsedPickupTime.hours() : null,
                selectedMinutes: parsedPickupTime ? parsedPickupTime.minutes() : null,
                successMessage,
                groupId: selectedRoomId,
            }));
        }
    }, [selectedRoomId, child, timezone, accessToken, dispatch, displayName, updateError]);
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { mx: 4, my: 3, children: [_jsx(Text, { variant: "h6", color: "n400", emphasized: true, children: translate('moveToRoomQuestion', { childName: child.name.firstName }) }), _jsx(CardsContainer, { mt: 2, children: groups.map(group => (_jsx(Card, { alignment: "vertical", image: group.image.large, displayTitle: group.title, onClick: () => setSelectedRoomId(group.groupId), selected: group.groupId === selectedRoomId }, group.groupId))) })] }), _jsx(BottomBarContainer, { children: _jsx(ActionOnClickButton, { backgroundColor: "g400", color: "n0", borderColor: "g400", text: `Move ${displayName} to ${selectedRoom === null || selectedRoom === void 0 ? void 0 : selectedRoom.title}`, onClick: handleChildSwitchRoom }) })] }));
};
